import get from 'lodash/get';

import {getJsonRequest} from '~/src/utilities/helpers/request';
import {getApiRequest} from '~/src/utilities/feed/api.js';
import {Logger} from '~/src/utilities/helpers/log';

class Envelope {
    constructor(envelope) {
        this.envelope = envelope;
    }

    async loadData(url, type) {
        if (type === 'content') {
            try {
                return await getJsonRequest(url, {});
            } catch (error) {
                Logger.info(`[${error.name}][Envelope] error while fetching envelope data`, {error, url});
            }
        }

        return null;
    }

    async dataConverter(data) {
        const {id, type, attributes, relationships} = data;
        let returnObj = {
            id,
            type,
            ...attributes
        };

        if (relationships) {
            const keys = Object.keys(attributes).filter((key) => relationships[key]);
            for (let key of keys) {
                const response = await this.loadData(relationships[attributes[key].type], attributes[key].type);
                if (response) {
                    returnObj[key] = response;
                }
            }
        }
        return returnObj;
    }

    getData() {
        if (this.envelope.data.constructor === Object) {
            return this.dataConverter(this.envelope.data);
        }
        if (this.envelope.data.constructor === Array) {
            return Promise.all(
                this.envelope.data.map((entry) => {
                    return this.dataConverter(entry);
                })
            );
        }
    }

    getMeta() {
        return this.envelope.meta;
    }

    getRaw() {
        return this.envelope;
    }

    getNextLink() {
        return get(this.envelope, 'links.next');
    }

    getNextPage() {
        const nextUrl = this.getNextLink();
        if (nextUrl) {
            return getApiRequest(nextUrl, true);
        }
        return Promise.reject();
    }

    getPreviousPage() {
        return new Envelope(null);
    }
}

export {Envelope};
